import { api } from '@/api'
import type { AppDispatch } from '@/store'
import type { PedidoEmAberto } from '@/store/self-service-kiosk-slice'

export function reverterTaxaServicoSePendente(dispatch: AppDispatch, pedido: PedidoEmAberto | null): void {
    if (!pedido?.idPedidoIntegracao || !pedido.taxaServicoDispensada) return
    if ((pedido.valorRecebido ?? 0) > 0) return

    const requisicao = dispatch(
        api.endpoints.alterarTaxaServicoTotem.initiate(
            { idPedidoIntegracao: pedido.idPedidoIntegracao, acao: 'REAPLICAR' },
            { track: false },
        ),
    )

    requisicao.unwrap().catch((e) => {
        console.error('Falha ao reverter a dispensa da taxa de serviço:', e)
    })
}
